import styled from 'styled-components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

import {
  Divider as SharedDivider,
  Typography as SharedTypography,
  Button as CommonButton,
} from 'primsell-shared-layer/components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const ConnectWalletContainer = styled.div`
  margin-top: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DescriptionTypography = styled(SharedTypography)`
  @media ${baseTheme.device.laptop} {
    margin-right: 35%;
  }
`

export const DisconnectButton = styled(CommonButton)`
  @media screen and (max-width: 400px) {
    margin-left: 8px;
  }
`

export const WalletInfoTypography = styled(SharedTypography)`
  display: inline;
  color: ${baseTheme.colors.dark100};
  font-size: 16px;
  font-weight: 500;
`

export const WalletInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const WalletInfoLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Divider = styled(SharedDivider)`
  margin-top: 12px;
  margin-bottom: 20px;
`

export const ProceedTypography = styled(SharedTypography)`
  max-width: 300px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`
